import { Icon } from '@chakra-ui/react'
import { EllipsisVertical } from 'lucide-react'
import React from 'react'

export const MoreMenuIcon: React.FC = () => (
  <Icon boxSize={4}>
    <EllipsisVertical size="100%" />
  </Icon>
)
